export const ABOVE_CONTRACT_TOOLTIP =
  "You're running above your contracted workers. Time spent above the limit draws down your burst budget.";

export const BURST_BUDGET_TOOLTIP =
  "Your contract allows a share of the cycle's minutes to run above your contracted workers without overage — a finite burst allowance. This shows how much you've used and have left for the rest of the cycle.";

export const ZERO_BURST_BUDGET_TOOLTIP =
  "Your contract includes no burst allowance, so any time spent above your contracted workers may incur overage charges.";

export const PEAK_TOOLTIP =
  "The highest concurrent private worker count reached on any day of the cycle so far.";

export const MULTI_ACCOUNT_CONTRACT_VALUE = "N/A";

export const MULTI_ACCOUNT_CONTRACT_CAPTION = "Shared across accounts";

export const MULTI_ACCOUNT_CONTRACT_PERCENTILE_CAPTION = "This account only";

export const MULTI_ACCOUNT_CONTRACT_BURST_TOOLTIP =
  "Your burst allowance is pooled across the accounts on your contract, so it can't be measured for this account alone. Your Customer Success Manager can help with overage calculations.";
